import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const CopyIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M4 5C4 3.34315 5.34315 2 7 2H15C15.5523 2 16 2.44772 16 3C16 3.55228 15.5523 4 15 4H7C6.44772 4 6 4.44772 6 5V17C6 17.5523 5.55228 18 5 18C4.44772 18 4 17.5523 4 17V5ZM7 8C7 6.34315 8.34315 5 10 5H17C18.6569 5 20 6.34315 20 8V19C20 20.6569 18.6569 22 17 22H10C8.34315 22 7 20.6569 7 19V8ZM10 7C9.44772 7 9 7.44772 9 8V19C9 19.5523 9.44772 20 10 20H17C17.5523 20 18 19.5523 18 19V8C18 7.44772 17.5523 7 17 7H10Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

CopyIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(CopyIcon);
